<!-- use tags -->

import Layout1 from "../../src/routes/game/444dle/+layout.marko";
import Page from "../../src/routes/game/444dle/+page.marko";

<Layout1>
	<Page/>
</>
